import styled, { css } from 'styled-components';
import { shadow } from 'styled-system';
import { getMediaQuery, getPaletteColor, color, themeGet } from '@magalu/stereo-ui-styles';
import { ChevronLeft, ChevronRight } from '@magalu/stereo-ui-icons';
import Box from '../../atoms/Box';
import Text from '../../atoms/Text';
import { BaseButtonStyle } from '../../atoms/BaseButton/base-button.styles';
const baseArrowsAttrs = {
  color: 'primary.base',
  width: 40,
  height: 40
};
export const Container = styled(Box)`
  position: relative;
  overflow: hidden;
`;
export const CarouselContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
  position: relative;

  ${({
  showControls
}) => showControls && css`
      padding-bottom: ${props => props.insideControls ? '0' : '25'}px;
    `};

  max-height: ${({
  itemHeight
}) => itemHeight ? `${itemHeight}px` : null};
`;
export const CarouselItem = styled(Box).attrs(({
  gutter,
  alignContent
}) => ({
  pr: gutter ? `${gutter}px` : null,
  va: alignContent ? `${alignContent}` : null
}))`
  width: ${({
  width = '50%'
}) => width};
  &:first-child {
    padding-left: ${({
  gutter
}) => gutter ? `${gutter}px` : null};
  }
  transition: box-shadow 0.4s ease 0s;
  align-content: ${({
  alignContent = null
}) => alignContent};
`;
export const CarouselContainer = styled.div`
  overflow: hidden;

  ${({
  showArrowControls
}) => showArrowControls && css`
      margin: ${props => props.insideControls ? '0px' : '0px 40px'};
    `};
`;
export const ArrowsControlsButton = styled.button`
  ${BaseButtonStyle}

  background: rgba(255, 255, 255, 0.5);
  width: fit-content;
  height: fit-content;
  position: absolute;
  top: calc((100% - 40px) / 2);
  cursor: ${({
  disabled
}) => disabled ? 'default' : 'pointer'};

  ${props => props.left && css`
      left: 0;
    `}

  ${props => props.right && css`
      right: 0;
    `}
  
  ${props => props.insideControls && css`
      z-index: 2;
    `}

  ${shadow}
  ${color}
`;
export const PrevIcon = styled(ChevronLeft).attrs(props => Object.assign({}, baseArrowsAttrs, props))`
  ${color}
`;
export const NextIcon = styled(ChevronRight).attrs(props => Object.assign({}, baseArrowsAttrs, props))`
  ${color}
`;
export const CarouselIndicators = styled.ol`
  position: absolute;
  right: 0;
  bottom: ${props => props.insideControls ? themeGet('space.3')(props) : 0}px;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding-left: 0;
  list-style: none;
  margin: auto;
`;
export const CarouselIndicator = styled.li`
  position: relative;
  flex: 0 1 auto;
  width: 8px;
  height: 8px;
  margin: 0 0.3em;
  cursor: pointer;
  border: solid 1.2px;
  border-radius: 4px;

  ${props => {
  return props.active ? `
        background: ${getPaletteColor('text.scratched')(props)};
        border-color: ${getPaletteColor('text.scratched')(props)};
      ` : `
        background: ${getPaletteColor('background.lighter')(props)};
        border-color: ${getPaletteColor('text.scratched')(props)};
      `;
}}

  ${getMediaQuery('small')} {
    width: 10px;
    height: 10px;
    border-radius: 8px;
  }
`;
export const SlideCount = styled(Text)`
  margin-top: 10px;
  color: #697277;
  display: flex;
  justify-content: center;
`;